import { render } from "./GetMembers.vue?vue&type=template&id=8d25cbcc"
import script from "./GetMembers.vue?vue&type=script&lang=js"
export * from "./GetMembers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__